import * as PIXI from 'pixi.js';
import { Point } from './geometry';

/** Visual parameters for a dotted line: dash geometry and stroke appearance. */
export interface DottedLineStyle {
  dotSpacing: number;
  dotLength: number;
  width: number;
  color: number;
  alpha: number;
}

/**
 * Draws a dotted line between two points onto the given graphics object.
 * Each dash is a short stroked segment; a zero-length line draws nothing.
 */
export function drawDottedLine(
  graphics: PIXI.Graphics,
  start: Point,
  end: Point,
  style: DottedLineStyle
): void {
  const dx = end.x - start.x;
  const dy = end.y - start.y;
  const distance = Math.sqrt(dx * dx + dy * dy);

  if (distance === 0) {
    return;
  }

  const numSegments = Math.floor(distance / style.dotSpacing);

  for (let i = 0; i < numSegments; i++) {
    const t1 = (i * style.dotSpacing) / distance;
    const t2 = Math.min((i * style.dotSpacing + style.dotLength) / distance, 1);

    graphics.moveTo(start.x + dx * t1, start.y + dy * t1);
    graphics.lineTo(start.x + dx * t2, start.y + dy * t2);
    graphics.stroke({ width: style.width, color: style.color, alpha: style.alpha });
  }
}
